export const COIN_GECKO_URL = "https://api.coingecko.com/api/v3/coins/";
export const COIN_GECKO_ERC20_URL =
  "https://api.coingecko.com/api/v3/coins/ethereum/contract/";
export const ETHEREUM_ID = "ethereum";
export const WHALE_ADDRESS = "0x9355372396e3f6daf13359b7b607a3374cc638e0";
export const LITE_ADDRESS = "0x35872fea6a4843facbcdbce99e3b69596a3680b8";
